import {TemplateList} from "~/libs/constants/TemplateList"
import type StaticHeaderConfig from "~/libs/interfaces/StaticHeaderConfig"

export const HeaderConfig: Record<TemplateList, StaticHeaderConfig> = {
  [TemplateList.POGGERS]: {
    stickyTopOffset: 360,
  },
  [TemplateList.MATERIDOUSKA]: {
    stickyTopOffset: 425,
  },
}